import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

/**
 * Gates the In-Session Templates management UI (the navbar link and the
 * management page). Defaults OFF.
 */
export const useInSessionTemplatesManagement = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.IN_SESSION_TEMPLATES_MANAGEMENT);
